"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _hoc = require("@package/hoc");

var _profile = require("@widget/profile");

var _utils = require("@package/utils");

var _dialog = require("@package/dialog");

var _functionalButton = require("@widget/functional-button");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ButtonList = _interopRequireDefault(require("./ButtonList"));

var _ShopCreate = _interopRequireDefault(require("./ShopCreate"));

var _UserModify = _interopRequireDefault(require("./UserModify"));

var _TwoFA = _interopRequireDefault(require("./TwoFA"));

var _PayoutCreate = _interopRequireDefault(require("./PayoutCreate"));

var _TransferCreate = _interopRequireDefault(require("./TransferCreate"));

var _InvoiceCreate = _interopRequireDefault(require("./InvoiceCreate"));

var _InvoiceUrlSuccess = _interopRequireDefault(require("./InvoiceUrlSuccess"));

var _PayoutFromFile = _interopRequireDefault(require("./PayoutFromFile"));

var _PayoutFileSuccess = _interopRequireDefault(require("./PayoutFromFile/PayoutFileSuccess"));

var _ExchangeCreate = _interopRequireDefault(require("./ExchangeCreate"));

var _ExchangeSuccess = _interopRequireDefault(require("./ExchangeSuccess"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Widget() {
  try {
    var dispatch = (0, _reactRedux.useDispatch)();
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);

    if (!profile) {
      return null;
    }

    var isInvoiceAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'operation.invoice.add');
    var isPayoutAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'operation.payout.add');
    var isTransferAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'operation.transfer.add');
    var isShopAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'shop.add');
    var isUserAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'user.add');
    var isUserUpdatePermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'user.update');
    var isExchangeAddPermission = (0, _utils.checkPermission)(profile['user']['permissions'], 'operation.exchange.add');
    var isShowPayout = profile['merchant']['type'] === 'INDIVIDUAL' || ['LEGAL', 'ST'].indexOf(profile['merchant']['type']) !== -1 && (profile['merchant']['subaggregator'] || profile['merchant']['c2cMarketplace']) && profile['merchant']['status']['type'] === 'Moderated';
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement(_ButtonList["default"], {
      items: [isInvoiceAddPermission && {
        _data: 'create-invoice',
        title: 'Счет',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-invoice'));
        }
      }, isPayoutAddPermission && isShowPayout && {
        _data: 'create-payout',
        title: 'Выплату',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-payout'));
        }
      }, isPayoutAddPermission && isShowPayout && {
        _data: 'create-payout.file',
        title: 'Выплаты из файла',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-payouts-from-file'));
        }
      }, isPayoutAddPermission && isShowPayout && isTransferAddPermission && {
        _data: 'create-transfer',
        title: 'Перевод',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-transfer'));
        }
      }, isShopAddPermission && {
        _data: 'create-shop',
        title: 'Магазин',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-shop'));
        }
      }, isUserAddPermission && {
        _data: 'create-user',
        title: 'Сотрудника',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-user'));
        }
      }, isExchangeAddPermission && profile['merchant']['type'] === 'INDIVIDUAL' && {
        _data: 'create-exchange',
        title: 'Обмен валют',
        onClick: function onClick() {
          dispatch((0, _dialog.openDialog)('create-exchange'));
        }
      }]
    }), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-shop",
      title: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430",
      name: "create-shop"
    }, /*#__PURE__*/_react["default"].createElement(_ShopCreate["default"], null)), isInvoiceAddPermission && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-invoice",
      title: "\u0412\u044B\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0447\u0435\u0442",
      name: "create-invoice"
    }, /*#__PURE__*/_react["default"].createElement(_InvoiceCreate["default"], null)), isInvoiceAddPermission && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "invoice.url.success",
      name: "invoice-url-success"
    }, /*#__PURE__*/_react["default"].createElement(_InvoiceUrlSuccess["default"], null)), isUserAddPermission && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "user-create",
      name: "create-user",
      title: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430"
    }, /*#__PURE__*/_react["default"].createElement(_UserModify["default"], null)), isUserUpdatePermission && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "user-update",
      name: "update-user"
    }, /*#__PURE__*/_react["default"].createElement(_UserModify["default"], null)), isShowPayout && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-payout",
      title: "\u0412\u044B\u0432\u043E\u0434 \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
      name: "create-payout"
    }, /*#__PURE__*/_react["default"].createElement(_PayoutCreate["default"], null)), isShowPayout && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-payouts-from-file",
      title: "\u0412\u044B\u043F\u043B\u0430\u0442\u044B \u0438\u0437 \u0444\u0430\u0439\u043B\u0430",
      name: "create-payouts-from-file"
    }, /*#__PURE__*/_react["default"].createElement(_PayoutFromFile["default"], null)), isShowPayout && isTransferAddPermission && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-transfer",
      title: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
      name: "create-transfer"
    }, /*#__PURE__*/_react["default"].createElement(_TransferCreate["default"], null)), isShowPayout && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "confirm-twoFA",
      name: "confirm-twoFA"
    }, /*#__PURE__*/_react["default"].createElement(_TwoFA["default"], null)), isExchangeAddPermission && /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-exchange",
      title: "\u041E\u0431\u043C\u0435\u043D \u0432\u0430\u043B\u044E\u0442",
      name: "create-exchange"
    }, /*#__PURE__*/_react["default"].createElement(_ExchangeCreate["default"], null)), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "payout-from-file-success",
      name: "payout-from-file-success"
    }, /*#__PURE__*/_react["default"].createElement(_PayoutFileSuccess["default"], null)), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      _data: "create-exchange-success",
      name: "create-exchange-success"
    }, /*#__PURE__*/_react["default"].createElement(_ExchangeSuccess["default"], null)));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Widget;
exports["default"] = _default;